import { getSessionStorageItem } from '../helpers/sessionStorage'

const useDSApplicationMode = () => {
  const mode = getSessionStorageItem('mode') || 'WEB'
  return mode
}

export default useDSApplicationMode
